export const getLoggedStatus = () =>
  localStorage.getItem("loggedIn") === "true";

export const getLoggedUser = () => {
  const user = localStorage.getItem("loggedUser");
  return user ? JSON.parse(user) : null;
};

export const getStoredToken = () => localStorage.getItem("token");
export const removeLoggedStatus = () => localStorage.removeItem("loggedIn");
export const removeLoggedUser = () => localStorage.removeItem("loggedUser");
export const removeToken = () => localStorage.removeItem("token");
export const storeLoggedStatus = (status: any) =>
  localStorage.setItem("loggedIn", status);
export const storeLoggedUser = (user: any) =>
  localStorage.setItem("loggedUser", user);
export const storeToken = (token: string) =>
  localStorage.setItem("token", token);

const STORAGE_ONBOARDING_SHOWN_KEY = "onboardingShown";

const getOnboardingStorageKey = (user: any) => {
  if (!user) return null;
  return user.id || user.idPessoa || user.email;
};

export const isOnboardingShown = (user: any) => {
  const key = getOnboardingStorageKey(user);
  if (!key) return false;
  return (
    localStorage.getItem(`${STORAGE_ONBOARDING_SHOWN_KEY}:${key}`) === "true"
  );
};

export const storeOnboardingShown = (user: any) => {
  const key = getOnboardingStorageKey(user);
  if (!key) return;
  localStorage.setItem(`${STORAGE_ONBOARDING_SHOWN_KEY}:${key}`, "true");
};

export const STORAGE_SEARCH_QUERY_KEY = "searchQuery";

export const getStoredSearchQuery = (): string => {
  try {
    const query = localStorage.getItem(STORAGE_SEARCH_QUERY_KEY);
    return query || "";
  } catch {
    return "";
  }
};

export const storeSearchQuery = (query: string) => {
  try {
    if (query && query.trim().length > 0) {
      localStorage.setItem(STORAGE_SEARCH_QUERY_KEY, query);
    }
  } catch {}
};

export const removeSearchQuery = () => {
  try {
    localStorage.removeItem(STORAGE_SEARCH_QUERY_KEY);
  } catch {}
};

export const STORAGE_SEARCH_TYPE_KEY = "searchType";

export const getStoredSearchType = (): string => {
  try {
    const searchType = localStorage.getItem(STORAGE_SEARCH_TYPE_KEY);
    return searchType || "";
  } catch {
    return "";
  }
};

export const storeSearchType = (searchType: string) => {
  try {
    if (searchType && searchType.trim().length > 0) {
      localStorage.setItem(STORAGE_SEARCH_TYPE_KEY, searchType);
    }
  } catch {}
};

export const removeSearchType = () => {
  try {
    localStorage.removeItem(STORAGE_SEARCH_TYPE_KEY);
  } catch {}
};
